<template>
    <grayBlackList :shoptype="shoptype" :changeModule="changeModule"/>
</template>
<script>
import grayBlackList from "../grayBlackList/main"
export default {
    components:{grayBlackList},
    data(){
        return {
            shoptype:"2",
            changeModule:"HcmShopGreyList"
        }
    }
}
</script>

